export * from './templated-dialog.component';
